import React from "react";

const Preview = () => {
    return <div> <iframe
    style={{ width: "100%", height: "calc(100vh - 280px)" }}
    src={`${process.env.REACT_APP_RESTAURANT_PREVIEW_URL}`}
    title="Website Preview"
  ></iframe></div>
};
export default Preview;
